import { Fragment, useEffect, useState } from 'react';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import HeaderWithTitle from '../Shared/Components/HeaderWithTitle';
import { configService } from "../../Services/Config/ConfigService";
import AbpnSpinner from '../Shared/Components/AbpnSpinner';

interface IProps {
	showLogin: boolean;
	showSearchAgain: boolean;
	hascompletedResidency: boolean;
	searchAgain: () => void;
}
export function AccountAssistance(props: IProps) {
	const [mailToLink, setMailToLink] = useState<string>(null);
	const [updatePersonalInfoLink, setUpdatePersonalInfoLink] = useState<string>(null);

	useEffect(() => {
		const getMailToLink = () => {
			configService.getConfiguration().then(_ => {
				setMailToLink(_.PhysicianPortalHelp);
			})
		}
		const getUpdatePersonalInfoLink = () => {
			configService.getConfiguration().then(_ => {
				setUpdatePersonalInfoLink(_.UpdatePersonalInfoInstructions);
			})
		}
		getMailToLink();
		getUpdatePersonalInfoLink();
	}, [])
    
	if (!mailToLink || !updatePersonalInfoLink) return <AbpnSpinner/>
	return (
		<Container>
			<HeaderWithTitle title=" Account Assistance" subTitle={null} contactMessage={false} />
			<Card border="pp-secondary-grey">
				<Card.Body>
					<Row>
						<Col>
							<Card.Text className="pp-font-size-smaller">
								{props.hascompletedResidency ? (
									<Fragment>
										<p>Your account could not be activated with the information you provided</p>
										<strong>If you are currently in a residency program:</strong>
										<p>
											Please check with your residency program to ensure your last name, date of
											birth, and last four of your social security number have been into the ABPN
											preCert system. If the information had been entered incorrectly, refer to the
											<a target="_blank" href={updatePersonalInfoLink}> Update Personal Information</a> document for further instructions.
										</p>

										<strong>If you are NOT currently in a residency program:</strong>
										<p>
											Please contact ABPN through email at <a href={mailToLink}>questions@abpn.org</a>{' '}
											with subject "Physician Portal Help” for assistance.
										</p>
									</Fragment>) : (
									<p>We are having trouble locating your account. Please contact ABPN through email at{' '}
										<a href={mailToLink}>questions@abpn.org</a> with subject "Physician
										Portal Help” for assistance.
									</p>
								)}
							</Card.Text>
						</Col>
					</Row>
					<Row>
						<Col>
							<Button variant="pp-primary" className="mt-4" type="button" onClick={() => window.open(mailToLink)}>
								Email ABPN
							</Button>
							{(props.showSearchAgain || props.hascompletedResidency) && (
								<Button
									variant="outline-pp-primary"
									className="mt-4 ml-2"
									type="button"
									onClick={() => props.searchAgain()}
								>
									Search for Account Again
								</Button>
							)}
							{props.showLogin && (
								<Link to="/">
									<Button variant="outline-pp-primary" className="mt-4 ml-2">
										Log In
									</Button>
								</Link>
							)}
						</Col>
					</Row>
				</Card.Body>
			</Card>
		</Container>
	);
}

export default AccountAssistance;
